// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0c1b376991860e6270dacbc61d443fd2169ee1ac/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};